
export const currentFormatTime = () => {
    const date = new Date();

    return `${date.getHours() >= 10 ? date.getHours() : '0'+date.getHours()}:${date.getMinutes() >= 10 ? date.getMinutes() : '0'+date.getMinutes()}:${date.getSeconds() >= 10 ? date.getSeconds() : '0'+date.getSeconds()}`
}

export const log = (logs) => {
    console.log(logs.join(' '), currentFormatTime());
}